module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-box-image-sp-a88c0ff2a9c94ff1a869e141a90eca95.png";